import { memo } from "react";

import { StarRatingDisplay } from "@/components/star-rating";

// Helper function to render assignee name only (simplified for Active tab)
export const renderSimpleAssignee = (assignee: unknown) => {
  if (!assignee || typeof assignee !== "object" || !("name" in assignee)) {
    return <span className="text-text-tertiary">--</span>;
  }

  const assigneeValue = assignee as {
    id: number;
    name: string;
    profilePictureUrl?: string;
    role?: number;
  };

  return (
    <div className="line-clamp-3 break-words">
      <span className="text-sm font-medium text-text-primary">
        {assigneeValue.name}
      </span>
    </div>
  );
};

const RatingIcon = memo(({ rating }: { rating?: null | number }) => (
  <div className="flex items-center">
    <StarRatingDisplay value={rating} />
  </div>
));

RatingIcon.displayName = "RatingIcon";

export const renderRating = (rating?: null | number) => (
  <RatingIcon rating={rating} />
);
